import React, { useState, useEffect } from 'react';
import CollapsibleItem from './CollapsibleItem';
import SelectInput from './SelectInput';
import {timeParentsQuestions, timeParentsOptions} from '../constants';


const TimeParentsItem = (props) => {
  const {
    isCollapsible = true,
    name = '',
    parents = [],
    onUpdateTimes,
    onUpdateUnit,
    initialValues = [50,50],
    initialOption
  } = props

  const [ option, setOption ] = useState({label:'% (percent)', maxValue: 100 }); 
  const [ timeValues, setTimeValues ] = useState([50,50])

  useEffect(() => {
    if (initialOption){
      setOption(initialOption)
      setTimeValues([initialValues[0]/initialOption.maxValue*100,initialValues[1]/initialOption.maxValue*100])
    }
  }, [])


  const getParentLabel = (name) => {
    return timeParentsQuestions(name)[`${isCollapsible ? 'NOT_':''}EQUAL`]
  }

  const getPercentage = (v) => {
    return ([v[0]/option.maxValue*100,v[1]/option.maxValue*100])
  }

  const updateOption = (o) => {
    let value = timeValues.slice();
    value[0] = ((timeValues[0] /option.maxValue) * o.maxValue).toFixed(2);
    value[1] =( o.maxValue - value[0]).toFixed(2);
    setTimeValues(value);
    setOption(o);
    onUpdateUnit(o.index);
  }


  const updateValue = (valueInput,isRealTime,i) => {
    let value = timeValues.slice();
    let v = valueInput || 0;
    let anotherIndex = (i===0) ? 1 : 0;
    let newValue = ((v > option.maxValue) ? option.maxValue : v);
    value[anotherIndex] = (option.maxValue - newValue).toFixed(2);
    value[i] = isRealTime ? newValue : newValue.toFixed(2);
    onUpdateTimes(getPercentage(value,option))
    setTimeValues(value);
  }

  const renderContent = () => {
    return(
      <>
      { parents.map((item,index) => {
      return (
        <SelectInput
          label={getParentLabel(item.name)}
          options={timeParentsOptions}
          valueOption={option}
          valueInput={timeValues[index]}
          key={index}
          onChangeOption={(o)=>{
            updateOption(o);
          }}
          onChangeInput={(v,isRealTime=false)=>{
            updateValue(v,isRealTime,index);
          }}
          onRealTime
          classNameInput='text-align-right'
          widthInput={95}
          widthDropdown={203}
        />
      )
    })}
    </>
    )
  }
  if (isCollapsible) return (
    <CollapsibleItem
      titleSection={name}
      isSmall={true}
      descriptionSection="This section is for child support paid for children from other relationships. Do not include child support for any of the children who are in the current calculation."
    >
      {renderContent()}

    </CollapsibleItem>
  )

  return (
    renderContent()
  )
}

export default TimeParentsItem;

